/* -----------------------------------------------------------------------------------------------------
  - Created: [30-01-2025] by [SREERAJ]
  - Modified: [YYYY-MM-DD] 
  - Description: This file contains Schedule list
  -------------------------------------------------------------------------------------------------------
*/
import React, { useEffect, useState } from 'react';
import { Grid } from '@mui/joy';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import CustomTextFieldWithIcon from '../../../../Components/custom_components/custom_text_field/CustomTextFieldWithIcon';
import ActionButton from '../../../../Components/custom_components/CustomButtons/ActionButton/ActionButton';
import { FaRegFolderClosed } from 'react-icons/fa6';
import { GrUserWorker } from 'react-icons/gr';
import CustomTextArea from '../../../../Components/custom_components/CustomTextArea/CustomTextArea';
import CustomSelectDropdown from '../../../../Components/custom_components/CustomSelectDropdown/CustomSelectDropdown';
import { FaHashtag } from 'react-icons/fa';
import dayjs from 'dayjs';
import { statusOptions } from '../../../../utils/constants';
import { get_technology_with_pagination } from '../../../../config/Resource/technologyApis';
import { get_worksite_with_pagination } from '../../../../config/Worksite/siteApis';
import { get_workforce_with_pagination } from '../../../../config/Resource/workforceApis';
import { get_available_equipment_with_pagination, get_equipment_with_pagination } from '../../../../config/Resource/equipmentApis';
import CustomDatePicker from '../../../../Components/custom_components/CustomDatePicker/CustomDatePicker';
import { get_frequency } from '../../../../config/GeneralApis/GeneralApis';
import './ScheduleManagementFormStyle.css';
import { get_available_engineers } from '../../../../config/ReportApis/employeeReportApis';
import CustomCheckbox from '../../../../Components/custom_components/CustomCheckbox/CustomCheckbox';
import { convertToISO } from '../../../../utils/formatDate';

const ScheduleManagementForm = ({ handleSave, isButtonDisabled, id, formValues, isDisabled }) => {

    // Validation schema using Yup
    const validationSchema = Yup.object({
        SD_ScheduleCode: Yup.string().required('Schedule Code is required')
            .min(5, 'Schedule Code must be at least 5 characters')
            .max(20, 'Schedule Code must not exceed 20 characters.'),

        SD_Survey_from_date: Yup.string()
            .required('Survey From Date is required'),
        // SD_Survey_from_date: Yup.string()
        //     .required("Survey From date is required")
        //     .test("not-in-past", "Past dates are not allowed", (value) => {
        //         const selectedDate = dayjs(value, "DD-MM-YYYY", true); // 'true' enables strict parsing
        //         if (!selectedDate.isValid()) return false;
        //         return selectedDate.isSame(today) || selectedDate.isAfter(today);
        //     }),
        SD_Survey_end_date: Yup.string()
            .required('Survey To Date is required')
            .test(
                'end-date-after-start-date',
                'End date cannot be before start date',
                function (value) {
                    const { SD_Survey_from_date } = this.parent;

                    const startDate = new Date(convertToISO(SD_Survey_from_date) || '');
                    const endDate = new Date(convertToISO(value) || '');
                    return endDate >= startDate;
                }
            ),

        SD_TechnologyId: Yup.string().required('Technology is required'),
        SD_FrequencyId: Yup.string().required('Frequency is required'),
        // SD_ScheduleDescription: Yup.string().required('Description is required'),
        employee_ids: Yup.array().min(1, 'At least one employee is required'),
        // equipment_ids: Yup.array().min(1, 'At least one equipment is required'),
        SD_WorksiteId: Yup.string().required('Worksite is required'),
    });

    const [technologyListing, setTechnologyListing] = useState([]);
    const [worksiteListing, setWorksiteListing] = useState([]);
    const [workforceListing, setWorkforceListing] = useState([]);
    const [equipmentListing, setEquipmentListing] = useState([]);
    const [frequencyListing, setFrequencyListing] = useState([]);

    const [showFrequency, setShowFrequency] = useState(false);

    // TECHNOLOGIES
    const fetchTechnologies = async () => {
        try {
            const params = {
                status: isDisabled ? '' : 1 //1MEANS ACTIVE 
            }

            const response = await get_technology_with_pagination(params);
            if (response?.status === "success") {
                // Transform data into the desired format with label and value
                const transformedData = response.data.data?.map((item) => ({
                    label: item?.TechnologiesName,
                    value: item?.TechnologiesTypeId
                }));

                // Set the transformed data to the state
                setTechnologyListing(transformedData || []);
            } else {
                setTechnologyListing([]);
            }
        } catch (error) {
            console.error('Error fetching technologies:', error);
            setTechnologyListing([]);
        }
    };

    // FETCH WORKSITES 
    const fetchSites = async () => {
        try {
            const params = {
                status: isDisabled ? '' : 1  //1MEANS ACTIVE 
            }
            const response = await get_worksite_with_pagination(params);

            if (response?.status === "success") {
                // Transform data into the desired format with label and value
                const transformedData = response.data.data?.map((item) => ({
                    label: item?.worksiteName,
                    value: item?.WorksiteID,
                    type: item?.ProjectType
                }));

                // Set the transformed data to the state
                setWorksiteListing(transformedData || []);
            } else {
                setWorksiteListing([]);
            }
        } catch (error) {
            console.error('Error fetching :', error);
            setWorksiteListing([]);
        }
    };

    const fetchFrequencies = async () => {
        try {

            const response = await get_frequency();
            if (response?.status === "success") {

                // Transform data into the desired format with label and value
                const transformedData = response.data?.map((item) => ({
                    label: item?.FL_Frequency,
                    value: item?.FL_Id
                }));

                // Set the transformed data to the state
                setFrequencyListing(transformedData || []);
            } else {
                setFrequencyListing([]);
            }
        } catch (error) {
            console.error('Error fetching technologies:', error);
            setFrequencyListing([]);
        }
    };

    // FOR GET TECHNOLOGIES FROM LIST
    useEffect(() => {
        fetchTechnologies();
        fetchSites()
        fetchFrequencies()
        // fetchWorkforce()

    }, []);


    // FETCH fetchWorkforce
    const fetchWorkforce = async () => {
        try {
            let params = {};
            let response;

            if (formik.values.is_urgent) {
                // When urgent → get all workforce (RoleID: 5) 5 =fse's ,2 means superviosr
                params = {
                    userRoles: `5,2`,
                    status: isDisabled ? '' : 1,
                };
                response = await get_workforce_with_pagination(params);
            } else {
                // When not urgent → get available engineers by date
                params = {
                    start_date: formik.values.SD_Survey_from_date,
                    end_date: formik.values.SD_Survey_end_date,
                    status: isDisabled ? '' : 1,
                    schedule_id: id ? id : ''
                };
                response = await get_available_engineers(params);
            }

            if (response?.status === "success") {

                const responseData = formik.values.is_urgent ? response?.data?.data : response?.data
                const transformedData = responseData?.map(item => ({
                    label: formik.values.is_urgent ? item?.UD_name : item?.EngineerName,
                    value: formik.values.is_urgent ? item?.UD_ID : item?.id,
                }));

                setWorkforceListing(transformedData || []);
            } else {
                setWorkforceListing([]);
            }
        } catch (error) {
            console.error('Error fetching :', error);
            setWorkforceListing([]);
        }
    };

    // FETCH EquipmentList 
    const fetchEquipmentList = async () => {
        try {
            const params = {
                TechnologyId: formik.values.SD_TechnologyId,
                status: isDisabled ? '' : 1,  //1MEANS ACTIVE 
                Survey_from_date: formik.values.SD_Survey_from_date,
                Survey_end_date: formik.values.SD_Survey_end_date,
                schedule_id: id ? id : '',
                is_urgent: formik.values.is_urgent
            };
            // NEW PARAMS
            const response = await get_available_equipment_with_pagination(params);

            // const response = await get_equipment_with_pagination(params);
            if (response?.status === "success") {
                const transformedData = response?.data?.map((item) => ({
                    label: `${item?.EquipmentName} (${item?.EquipmentserialNo || ''})`,
                    value: item?.EquipmentId,
                })) || [];

                setEquipmentListing(transformedData);

                // After updating latest equipment listing with ids,  (when no already selected ids is available in the list)
                const availableIds = transformedData.map(item => item.value);
                const validSelectedIds = formik.values.equipment_ids?.filter(id => availableIds.includes(id)) || [];
                formik.setFieldValue("equipment_ids", validSelectedIds);

            } else {
                setEquipmentListing([]);
                formik.setFieldValue("equipment_ids", []);
            }
        } catch (error) {
            console.error('Error fetching equipment list:', error);
            setEquipmentListing([]);
            formik.setFieldValue("equipment_ids", []);
        }
    };

    // SUBMISSION
    const formik = useFormik({
        initialValues: formValues,
        enableReinitialize: true, // Prevents infinite loop
        validationSchema: validationSchema,
        onSubmit: (values) => {
            handleSave(values, id)
        },
    });

    // Reset handler for the second form
    const handleReset = () => {
        formik.setFieldValue('SD_ScheduleCode', '');
        formik.setFieldValue('SD_Survey_from_date', '');
        formik.setFieldValue('SD_Survey_end_date', '');
        formik.setFieldValue('SD_TechnologyId', '');
        formik.setFieldValue('SD_FrequencyId', '');
        formik.setFieldValue('SD_ScheduleDescription', '');
        formik.setFieldValue('employee_ids', []);
        formik.setFieldValue('equipment_ids', []);
        formik.setFieldValue('SD_WorksiteId', '');

        formik.setFieldValue('is_urgent', formValues?.is_urgent === 1 ? 1 : 0);
        //  formik.setFieldValue('is_urgent', 0);

        // Reset warning messages (touched fields)
        formik.setTouched({
            SD_ScheduleCode: false,
            SD_Survey_from_date: false,
            SD_Survey_end_date: false,
            SD_TechnologyId: false,
            SD_FrequencyId: false,
            SD_ScheduleDescription: false,
            employee_ids: false,
            equipment_ids: false,
            SD_WorksiteId: false,
        });

        setShowFrequency(false)
    };


    // Call engineers immediately when date chnages

    useEffect(() => {
        if (formik.values.SD_Survey_from_date === `Invalid Date` || formik.values.SD_Survey_end_date === `Invalid Date`) {
            return
        } else {

            if (formik.values.SD_Survey_from_date && formik.values.SD_Survey_end_date) {
                const delayDebounceFn = setTimeout(() => {

                    fetchWorkforce();
                }, 500); // 500ms delay

                return () => clearTimeout(delayDebounceFn); // Cleanup timeout
            }
        }

    }, [formik.values.SD_Survey_from_date, formik.values.SD_Survey_end_date, formik.values.is_urgent]);

    // Call immediately when TechnologyId changes
    useEffect(() => {
        if (formik.values.SD_TechnologyId && formik.values.SD_Survey_end_date) {
            fetchEquipmentList();
        }
    }, [formik.values.SD_TechnologyId]);

    // Call with delay when Survey_end_date changes
    useEffect(() => {
        if (formik.values.SD_Survey_from_date === `Invalid Date` || formik.values.SD_Survey_end_date === `Invalid Date`) {
            return
        } else {
            if (formik.values.SD_TechnologyId && formik.values.SD_Survey_end_date) {
                const delayDebounceFn = setTimeout(() => {
                    fetchEquipmentList();
                }, 500); // 500ms delay

                return () => clearTimeout(delayDebounceFn); // Cleanup timeout
            }
        }

    }, [formik.values.SD_Survey_from_date, formik.values.SD_Survey_end_date, formik.values.is_urgent]);



    // FOR HIDE AND SHOW FREQUENCY WHEN PROJECT TYPE IS 1
    useEffect(() => {

        if (formik.values.SD_WorksiteId) {
            const selectedWorksite = worksiteListing?.find(
                (item) => item?.value === formik?.values?.SD_WorksiteId
            );
            const isTypeOne = selectedWorksite?.type === 1;
            setShowFrequency(isTypeOne); //   type is 1
            if (isTypeOne) {
                formik.setFieldValue("SD_FrequencyId", 0); // Set frequency to 0 if type is 1
            } else {
                formik.setFieldValue("SD_FrequencyId", formik?.values?.SD_FrequencyId || ""); //clear when type !=1
                setShowFrequency(false);
            }

        }
    }, [formik.values.SD_WorksiteId, worksiteListing]);

    return (
        <div className="taskform-form-container">
            <Grid container columnSpacing={3}>

                {/* checkbox */}
                <Grid item xs={12} md={12}>
                    <div className="taskform-mid-form-container">
                        <div className="label-container">
                        </div>
                        <div className="custom-textfield-container">

                            <CustomCheckbox
                                label="Urgent"
                                checked={formik.values.is_urgent === 1} // 1 Means urgent -- not urgent    
                                onChange={(e) => {
                                    formik.setFieldValue("is_urgent", e.target.checked ? 1 : 0);

                                }
                                }
                                disabled={formValues?.is_mobilize == 1 || formValues?.is_urgent ? true : false} //DISABLE WHEN THE SCHEDUELE IS URGENT OR MOBILIZED
                            />

                        </div>
                    </div>
                </Grid>

                {/* Schedule Dropdown */}
                <Grid item xs={12} md={6}>
                    <div className="taskform-mid-form-container">
                        <div className="label-container">
                            <span className="label">Schedule Code<span className="label_required_remark">*</span></span>
                        </div>
                        <div className="custom-textfield-container">

                            <CustomTextFieldWithIcon
                                id="SD_ScheduleCode"
                                name="SD_ScheduleCode"
                                placeholder="Schedule Code"
                                value={formik?.values?.SD_ScheduleCode}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                error={formik?.touched?.SD_ScheduleCode && Boolean(formik?.errors?.SD_ScheduleCode)}
                                helperText={formik?.touched?.SD_ScheduleCode && formik?.errors?.SD_ScheduleCode}
                                isDisabled={isDisabled}
                                maxLength={20}
                            />
                            <span className="example-field-label">eg: SCH-0001</span>

                        </div>
                    </div>
                </Grid>
                {/* Technology */}
                <Grid item xs={12} md={6}>
                    <div className="taskform-mid-form-container">
                        <div className="label-container">
                            <span className="label">Technology<span className="label_required_remark">*</span></span>
                        </div>
                        <div className="custom-textfield-container">
                            <CustomSelectDropdown
                                name="SD_TechnologyId"
                                placeholder="Select Technology"
                                options={technologyListing}
                                value={technologyListing?.find(option => option?.value === formik?.values?.SD_TechnologyId) || ""}
                                onChange={(selectedOption) => {
                                    formik.setFieldValue("SD_TechnologyId", selectedOption ? selectedOption.value : "");
                                }}
                                onBlur={formik.handleBlur}
                                error={formik.touched.SD_TechnologyId && Boolean(formik.errors.SD_TechnologyId)}
                                helperText={formik.touched.SD_TechnologyId && formik.errors.SD_TechnologyId}
                                StartIcon={<FaHashtag />}
                                isDisabled={isDisabled}
                                isMulti={false} // Set to false for single-select
                                width="100%"
                                isClearable={false}
                            />


                        </div>
                    </div>
                </Grid>


                {/* Survey From Date */}
                <Grid item xs={12} md={6}>
                    <div className="taskform-mid-form-container">
                        <div className="label-container">
                            <span className="label">Survey From <span className="label_required_remark">*</span></span>
                        </div>
                        <div className="custom-textfield-container">
                            <CustomDatePicker
                                name="SD_Survey_from_date"
                                label="Survey From "
                                onChange={(date) => {
                                    formik.setFieldValue("SD_Survey_from_date", date);
                                }}
                                onBlur={formik.handleBlur}
                                // value={dayjs(formik.values.SD_Survey_from_date, "DD-MM-YYYY")}
                                value={formik.values.SD_Survey_from_date ? dayjs(formik.values.SD_Survey_from_date, "DD-MM-YYYY") : null}
                                error={formik.touched.SD_Survey_from_date && Boolean(formik.errors.SD_Survey_from_date)}
                                helperText={formik.touched.SD_Survey_from_date && formik.errors.SD_Survey_from_date}
                                isDisabled={isDisabled}
                                minDate={dayjs()}
                            />
                        </div>
                    </div>
                </Grid>

                {/* Survey End Date */}
                <Grid item xs={12} md={6}>
                    <div className="taskform-mid-form-container">
                        <div className="label-container">
                            <span className="label">Survey To <span className="label_required_remark">*</span></span>
                        </div>
                        <div className="custom-textfield-container">

                            <CustomDatePicker
                                name="SD_Survey_end_date"
                                label="Survey To"
                                onChange={(date) => {
                                    formik.setFieldValue("SD_Survey_end_date", date);
                                }}
                                onBlur={formik.handleBlur}
                                // value={dayjs(formik.values.SD_Survey_end_date, "DD-MM-YYYY")}
                                value={formik.values.SD_Survey_end_date ? dayjs(formik.values.SD_Survey_end_date, "DD-MM-YYYY") : null}
                                error={formik.touched.SD_Survey_end_date && Boolean(formik.errors.SD_Survey_end_date)}
                                helperText={formik.touched.SD_Survey_end_date && formik.errors.SD_Survey_end_date}
                                isDisabled={isDisabled}
                                minDate={dayjs(formik.values.SD_Survey_from_date, "DD-MM-YYYY")} // restrict to after or same as from date
                            />
                        </div>
                    </div>
                </Grid>

                {/* Worksite */}
                <Grid item xs={12} md={6}>
                    <div className="taskform-mid-form-container">
                        <div className="label-container">
                            <span className="label">Worksite<span className="label_required_remark">*</span></span>
                        </div>
                        <div className="custom-textfield-container">

                            <CustomSelectDropdown
                                name="SD_WorksiteId"
                                placeholder="Select Worksite"
                                options={worksiteListing}
                                value={worksiteListing?.find(option => option?.value === formik?.values?.SD_WorksiteId) || ""}
                                onChange={(selectedOption) => {
                                    formik.setFieldValue("SD_WorksiteId", selectedOption ? selectedOption.value : "");
                                }}
                                onBlur={formik.handleBlur}
                                error={formik.touched.SD_WorksiteId && Boolean(formik.errors.SD_WorksiteId)}
                                helperText={formik.touched.SD_WorksiteId && formik.errors.SD_WorksiteId}
                                StartIcon={<FaRegFolderClosed />}
                                isDisabled={isDisabled}

                                isMulti={false} // Set to false for single-select
                                width="100%"
                                isClearable={false}
                            />
                        </div>
                    </div>
                </Grid>

                {/* SD_FrequencyId */}
                {!showFrequency && <Grid item xs={12} md={6}>
                    <div className="taskform-mid-form-container">
                        <div className="label-container">
                            <span className="label">Frequency<span className="label_required_remark">*</span></span>
                        </div>
                        <div className="custom-textfield-container">

                            <CustomSelectDropdown
                                name="SD_FrequencyId"
                                placeholder="Select Frequency"
                                options={frequencyListing}
                                value={frequencyListing?.find(option => option?.value === formik?.values?.SD_FrequencyId) || ""}
                                onChange={(selectedOption) => {
                                    formik.setFieldValue("SD_FrequencyId", selectedOption ? selectedOption.value : "");
                                }}
                                onBlur={formik.handleBlur}
                                error={formik.touched.SD_FrequencyId && Boolean(formik.errors.SD_FrequencyId)}
                                helperText={formik.touched.SD_FrequencyId && formik.errors.SD_FrequencyId}
                                StartIcon={<FaRegFolderClosed />}
                                isDisabled={isDisabled}
                                isMulti={false} // Set to false for single-select
                                width="100%"
                                isClearable={false}
                            />
                        </div>
                    </div>
                </Grid>}


                {/* Assigned Employees */}
                <Grid item xs={12} md={6}>
                    <div className="taskform-mid-form-container">
                        <div className="label-container">
                            <span className="label">Assigned Engineer<span className="label_required_remark">*</span></span>
                        </div>
                        <div className="custom-textfield-container">

                            <CustomSelectDropdown
                                name="employee_ids"
                                placeholder="Select Employees"
                                options={workforceListing}
                                value={workforceListing?.filter(option => formik.values.employee_ids?.includes(option.value))}
                                onChange={(selectedOptions) => {
                                    // Map selected options to extract only the `value` (ID) field
                                    const selectedValues = selectedOptions.map(option => option.value);
                                    // Set the field value with the array of selected IDs
                                    formik.setFieldValue("employee_ids", selectedValues);
                                }}
                                onBlur={formik.handleBlur}
                                error={formik.touched.employee_ids && Boolean(formik.errors.employee_ids)}
                                helperText={formik.touched.employee_ids && formik.errors.employee_ids}
                                isDisabled={isDisabled}

                                isMulti={true} // Set to true for multi-select
                                width="100%"
                            />

                        </div>
                    </div>
                </Grid>

                {/* Assigned Employees */}
                <Grid item xs={12} md={6}>
                    <div className="taskform-mid-form-container">
                        <div className="label-container">
                            <span className="label">Assigned Equipment</span>
                        </div>
                        <div className="custom-textfield-container">

                            <CustomSelectDropdown
                                name="equipment_ids"
                                placeholder="Select Equipment"
                                options={equipmentListing}
                                // value={equipmentListing?.filter(option => formik.values.equipment_ids?.includes(option.value))}
                                value={equipmentListing?.filter(option => formik.values.equipment_ids?.includes(option.value)) || []}
                                onChange={(selectedOptions) => {
                                    // Map selected options to extract only the `value` (ID) field
                                    const selectedValues = selectedOptions.map(option => option.value || []);
                                    // Set the field value with the array of selected IDs
                                    formik.setFieldValue("equipment_ids", selectedValues);
                                }}
                                onBlur={formik.handleBlur}
                                error={formik.touched.equipment_ids && Boolean(formik.errors.equipment_ids)}
                                helperText={formik.touched.equipment_ids && formik.errors.equipment_ids}
                                isDisabled={isDisabled}

                                isMulti={true} // Set to true for multi-select
                                width="100%"
                            />

                        </div>
                    </div>
                </Grid>
                {/* Status */}
                {id && <Grid item xs={12} md={6}>
                    <div className="taskform-mid-form-container">
                        <div className="label-container">
                            <span className="label">Status<span className="label_required_remark">*</span></span>
                        </div>
                        <div className="custom-textfield-container">

                            <CustomSelectDropdown
                                name="SD_Status"
                                placeholder="Select Status"
                                options={statusOptions}
                                value={statusOptions?.find(option => option?.value === formik?.values?.SD_Status) || ""}
                                onChange={(selectedOption) => {
                                    formik.setFieldValue("SD_Status", selectedOption ? selectedOption.value : "");
                                }}
                                onBlur={formik.handleBlur}
                                error={formik.touched.SD_Status && Boolean(formik.errors.SD_Status)}
                                helperText={formik.touched.SD_Status && formik.errors.SD_Status}
                                isDisabled={isDisabled}

                                isMulti={false} // Set to false for single-select
                                width="100%"
                            />

                        </div>
                    </div>
                </Grid>}

                {/* Description */}
                <Grid item xs={12}>
                    <div className="taskform-mid-form-container">
                        <div className="label-container">
                            <span className="label">Description</span>
                        </div>
                        <div className="custom-textfield-container">
                            <CustomTextArea
                                id="SD_ScheduleDescription"
                                name="SD_ScheduleDescription"
                                placeholder="Enter Description"
                                value={formik?.values?.SD_ScheduleDescription}
                                onChange={formik.handleChange}
                                rows={5}
                                isDisabled={isDisabled}
                            />
                        </div>
                    </div>
                </Grid>
            </Grid>


            {/* Action Buttons */}
            {!isDisabled && <div className="form-bottom-action-buttons-container">
                <ActionButton onClick={handleReset} label="Reset" btnType="outlined" />
                <ActionButton btnDisable={isButtonDisabled} onClick={formik.handleSubmit} label="Save" btnType="primary" />
            </div>}

        </div>
    );
};

export default ScheduleManagementForm;
